// @flow

import styled, { withTheme } from 'styled-components';
import { buildVersionSelector, colors, fontWeight } from '../constants';
import PrimaryPalette from '../../birch/colors';

const azaleaVersion = {
  linkColor: colors.mediumBlue,
  textDecoration: 'none',
};

const birchVersion = {
  linkColor: PrimaryPalette.darkGreen,
  textDecoration: 'underline',
};

const versionSelector = buildVersionSelector(azaleaVersion, birchVersion);

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const Link = styled.a`
  font-family: Untitled Sans, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => versionSelector(props.theme?.name).linkColor};
  text-decoration: ${(props) =>
    versionSelector(props.theme?.name).textDecoration};
  ${fontWeight('normal')}

  &:hover {
    text-decoration: underline;
  }
`;

export default withTheme(Link);
